import React from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Divider,
  useTheme,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const ContactAdmin = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 180px)",
        background: `linear-gradient(145deg, ${theme.palette.background.default} 0%, ${theme.palette.primary.main}0d 100%)`,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 6,
          px: 2,
        }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: 500,
            boxShadow: 5,
            borderRadius: 3,
            textAlign: "center",
            p: 3,
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
          }}
        >
          <CardContent>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: theme.palette.error.main,
                mb: 1,
              }}
            >
              Contact Administrator
            </Typography>

            <Typography variant="body1" sx={{ color: theme.palette.text.secondary, mb: 1.5 }}>
              Your application is currently awaiting verification. Access will be
              granted after an administrator approves it.
            </Typography>

            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 3 }}>
              Contact the administrator below if you need help or would like an
              update on your application.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: theme.palette.primary.main,
                mb: 2,
              }}
            >
              Administrator Details
            </Typography>

            <Box
              sx={{
                textAlign: "left",
                maxWidth: 360,
                mx: "auto",
                p: 2,
                borderRadius: 2,
                bgcolor: theme.palette.action.hover,
              }}
            >
              <Typography variant="body1" sx={{ mb: 1 }}>
                <strong>Name:</strong> BJS Administrator
              </Typography>
              <Typography
                component="a"
                href="mailto:info@bjsindia.org"
                variant="body1"
                sx={{
                  display: "block",
                  mb: 1,
                  color: "primary.main",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                <strong>Email:</strong> info@bjsindia.org
              </Typography>
              <Typography
                component="a"
                href="tel:+919545111551"
                variant="body1"
                sx={{
                  display: "block",
                  color: "primary.main",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                <strong>Phone:</strong> +91 9545111551
              </Typography>
            </Box>

            <Button
              variant="contained"
              startIcon={<ArrowBackIcon />}
              sx={{
                mt: 4,
                borderRadius: 2,
                textTransform: "none",
                px: 3,
                backgroundColor: theme.palette.primary.main,
                "&:hover": {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
              onClick={() => navigate("/")}
            >
              Back to Home
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default ContactAdmin;
